import React from 'react';
import styled from 'styled-components';

import PoweredBy from 'components/layout/PoweredBy';

interface IProps {
  className?: string;
}

const Footer = ({ className }: IProps) => {
  return (
    <Wrapper className={className} data-testid="footer">
      <PoweredBy />
    </Wrapper>
  );
};

export default Footer;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 2rem;
`;
